import { h } from 'preact';
import cn from 'classnames';
import { useEffect } from 'preact/hooks';

import Header from '../../containers/Header';
import App from '../../containers/App';
import ActionPanel from '../../containers/ActionPanel';
import Overlay from '../../containers/Overlay';
import ModalApp from '../../containers/ModalApp';
import Sidebar from '../../containers/Sidebar';
import Error from '../../containers/Error';
import Spinner from '../../containers/Spinner';
import { MODAL_ELEMENT_ID } from '../../constants';

const proxyAction = instances => action => {
  instances.forEach(getInstance => {
    const instance = getInstance();
    if (!instance || typeof instance.dispatchAction !== 'function') return;
    instance.dispatchAction(action);
  });
};

let app;
let overlay;
let sidebar;

const wrapInModal = (
  reactComponent,
  onCloseClick,
  isModalOpen,
  addHeader = false,
) => (
  <div // eslint-disable-line
    className={cn('as-Modalcontainer', {
      'is-open': isModalOpen,
    })}
    onClick={() => {
      proxyAction([() => overlay, () => sidebar, () => app])(onCloseClick());
    }}
  >
    <div // eslint-disable-line
      className={cn('as-Modal', {
        'is-open': isModalOpen,
      })}
      id={MODAL_ELEMENT_ID}
      onClick={e => {
        e.stopPropagation();
      }}
    >
      {addHeader && (
        <div class="as-Modalheader">
          <button class="as-Modalclose" onClick={onCloseClick}>
            <shore-icon name="delete" />
          </button>
        </div>
      )}
      {reactComponent}
    </div>
  </div>
);

const Main = ({
  deps = {},
  children,
  sidebarShown,
  modalOpen,
  currentModalApp = {},
  onModalAppLoaded,
  onModalCloseClick,
  changeLocation,
}) => {
  useEffect(() => {
    const router = deps.router;

    router.onChangeLocation(changeLocation, true);

    router.subscribe();

    return router.destroy;
  }, []);

  return (
    <div id="asMain" class="as-Main">
      <ActionPanel />
      <div class="as-Appwrapper">
        <Header
          trackMethod={deps.trackMethod}
          apiClient={deps.apiClient}
          eventBus={deps.eventBus}
        />
        <div
          class={cn('as-Body', { 'is-showingSidebar': sidebarShown })}
          id="asBody"
        >
          <App
            key={deps.name}
            {...deps}
            onProxyAction={proxyAction([() => overlay, () => sidebar])}
            onInstance={instance => {
              app = instance;
            }}
          />
          <Sidebar
            {...deps}
            onProxyAction={proxyAction([() => app])}
            onInstance={instance => {
              sidebar = instance;
            }}
          />
          {wrapInModal(null, onModalCloseClick, modalOpen)}
        </div>
        {wrapInModal(
          <ModalApp
            {...{
              ...deps,
              ...currentModalApp,
              onInstance(instance) {
                if (instance) {
                  onModalAppLoaded(instance);
                }
              },
            }}
          />,
          onModalCloseClick,
          currentModalApp.visible,
          true,
        )}
        <Overlay
          {...deps}
          onProxyAction={proxyAction([() => app])}
          onInstance={instance => {
            overlay = instance;
          }}
        />
        <Spinner />
        <Error />
        {children}
      </div>
    </div>
  );
};

export default Main;
